// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { GaContextFlags } from "../schema";

export function serialize_GaContextFlags_internal(value: GaContextFlags): unknown {
  return ((value: { alpha: boolean; beta: boolean; loggedIn: boolean }): unknown => {
    return {
      alpha: ((value: boolean): unknown => {
        return value;
      })(value["alpha"]),
      beta: ((value: boolean): unknown => {
        return value;
      })(value["beta"]),
      loggedIn: ((value: boolean): unknown => {
        return value;
      })(value["loggedIn"]),
    };
  })(value);
}
export function serialize_GaContextFlags(obj: GaContextFlags): string {
  return renderJsonWithNumbersAsBigint(serialize_GaContextFlags_internal(obj));
}
export function deserialize_GaContextFlags_internal(value: unknown): ParserResult<GaContextFlags> {
  return ((
    value: unknown,
  ): ParserResult<{
    alpha: boolean;
    beta: boolean;
    loggedIn: boolean;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/GaContextFlags]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/GaContextFlags]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "alpha")) {
      return { success: false, reason: `[#/components/schemas/GaContextFlags/alpha]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'alpha'.` };
    }
    const parsed_alpha = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/GaContextFlags/alpha]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["alpha"]);
    })();
    if (!parsed_alpha.success) {
      return { success: false, reason: parsed_alpha.reason };
    }
    if (!hasProp(value, "beta")) {
      return { success: false, reason: `[#/components/schemas/GaContextFlags/beta]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'beta'.` };
    }
    const parsed_beta = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/GaContextFlags/beta]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["beta"]);
    })();
    if (!parsed_beta.success) {
      return { success: false, reason: parsed_beta.reason };
    }
    if (!hasProp(value, "loggedIn")) {
      return { success: false, reason: `[#/components/schemas/GaContextFlags/loggedIn]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'loggedIn'.` };
    }
    const parsed_loggedIn = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/GaContextFlags/loggedIn]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["loggedIn"]);
    })();
    if (!parsed_loggedIn.success) {
      return { success: false, reason: parsed_loggedIn.reason };
    }
    return { success: true, value: { alpha: parsed_alpha.value, beta: parsed_beta.value, loggedIn: parsed_loggedIn.value } };
  })(value);
}
export function deserialize_GaContextFlags(str: string): ParserResult<GaContextFlags> {
  return deserialize_GaContextFlags_internal(parseJsonWithNumbersAsBigint(str));
}
